import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import RelayOffIcon from 'console/images/heating-circuit/relay-off.svg';
import RelayOnIcon from 'console/images/heating-circuit/relay-on.svg';
import { ResponsiveIcon, } from 'console/shared/components/icon/responsive';
export const RelayIndicator = memo(function RelayIndicator(props) {
    const { active, name, ...rest } = props;
    return (_jsx(ResponsiveIcon, { Icon: active ? RelayOnIcon : RelayOffIcon, opacity: active ? 1 : 0.7, fontSize: "0.6em", viewBox: "0 0 16 16", ...rest }));
});
